// extracted by mini-css-extract-plugin
export default {"Container":"Announcement_Container__-dNJI"};